/**
 * oddit-footer-main — newsletter signup via Klaviyo
 * -----------------------------------------------------------------------------
 * There is NO <form> / native submit in the markup — the button is
 * type="button" and submission is a pure `fetch` to Klaviyo's client-side
 * subscription API (Enter in the email field triggers the same path). With no
 * native submission, the page can never reload, under any outcome.
 *
 * Config (section settings, surfaced as data attributes on [data-newsletter]):
 *   data-klaviyo-key  → Klaviyo Public API Key (company_id)
 *   data-klaviyo-list → Klaviyo List ID to subscribe to
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

  function box(container) {
    return container.querySelector('.oddit-footer-main__newsletter-form');
  }

  function showSuccess(container) {
    var el = box(container);
    if (!el) return;
    var p = document.createElement('p');
    p.className = 'oddit-footer-main__newsletter-success';
    p.setAttribute('role', 'status');
    p.textContent = container.getAttribute('data-success-text') || 'Thanks for subscribing!';
    el.replaceChildren(p);
  }

  function showError(container, message) {
    var el = box(container);
    if (!el) return;
    var text = message || container.getAttribute('data-error-text') || 'Something went wrong. Please try again.';
    var existing = el.querySelector('.oddit-footer-main__newsletter-error');
    if (existing) { existing.textContent = text; return; }
    var p = document.createElement('p');
    p.className = 'oddit-footer-main__newsletter-error';
    p.setAttribute('role', 'alert');
    p.textContent = text;
    el.appendChild(p);
  }

  function subscribe(container) {
    if (container._klaviyoBusy) return;

    var input = container.querySelector('input[type="email"]');
    if (!input) return;
    // Use the browser's native validation UI for empty / invalid addresses.
    if (typeof input.checkValidity === 'function' && !input.checkValidity()) {
      if (typeof input.reportValidity === 'function') input.reportValidity();
      return;
    }

    // Only the List ID is needed for this endpoint (the `g` param).
    var listId = container.getAttribute('data-klaviyo-list');
    if (!listId) {
      showError(container, 'Newsletter isn’t configured yet.');
      return;
    }

    container._klaviyoBusy = true;
    var btn = container.querySelector('[data-newsletter-submit]');
    if (btn) btn.disabled = true;

    // Form-encoded body (no custom headers) → CORS "simple" request → no preflight.
    var body = 'g=' + encodeURIComponent(listId) + '&email=' + encodeURIComponent(input.value);

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body
    })
      .then(function (resp) {
        return resp.text().then(function (text) {
          container._klaviyoBusy = false;
          var data = null;
          try { data = JSON.parse(text); } catch (e) {}
          // kmail-lists returns { "success": true } (errors come back as
          // { "success": false, "errors": [...] }).
          var ok = resp.ok && !(data && data.success === false);
          if (ok) {
            showSuccess(container);
            return;
          }
          showError(container);
          if (btn) btn.disabled = false;
        });
      })
      .catch(function () {
        container._klaviyoBusy = false;
        showError(container);
        if (btn) btn.disabled = false;
      });
  }

  // Delegated listeners so this works regardless of when the footer renders,
  // if it's duplicated, or if the section is re-rendered in the editor.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-newsletter-submit]');
    if (!btn) return;
    var container = btn.closest('[data-newsletter]');
    if (container) subscribe(container);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target;
    if (!input || !input.closest || input.type !== 'email') return;
    var container = input.closest('[data-newsletter]');
    if (!container) return;
    e.preventDefault(); // no form to submit, but stop any default Enter handling
    subscribe(container);
  });
})();
